import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DefaultIcon from '@material-ui/icons/Search';
const styles = {
  link: {
    textDecoration: 'none',
    color: 'black',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  label: {
    cursor: 'pointer'
  }
};
const IconColumn = props => {
  let children;
  let custom = props.custom;
  let data = {
    index: props.index,
    rowData: props.rowData
  };
  const iconClickHandler = () => {
    if (props.onClick && typeof props.onClick === 'function') {
      props.onClick(data);
    }
  };
  if (props.renderIcons) {
    children = props.renderIcons(data);
  } else if (props.children) {
    children = props.children;
  } else {
    children = /*#__PURE__*/React.createElement(DefaultIcon, null);
  }
  let style = custom ? typeof custom.style === 'function' ? custom.style(props.rowData, props.colData) : custom.style : {};
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "iconcolumn-div",
    className: "".concat(props.classes.label, " ").concat(props.testClass || ''),
    onClick: () => iconClickHandler(),
    style: style
  }, children);
};
export default withStyles(styles)(IconColumn);